import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminForgotPasswordMutation } from "@/features/api";
import { showApiError } from "@/lib/api-client";
import { AuthCard } from "@/pages/login";

export function ForgotPasswordPage() {
  const forgot = useAdminForgotPasswordMutation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      await forgot.mutateAsync({ email });
      setSent(true);
    } catch (err) {
      showApiError(err);
    }
  }

  return (
    <AuthCard
      title="Şifre belirle"
      description="İlk girişte veya şifreni unuttuysan e-postana bir link gönderelim."
    >
      {sent ? (
        <div className="space-y-4 text-center text-sm">
          <p>
            Bu adres kayıtlı bir admin hesabına aitse şifre linki gönderildi. Link 1 saat
            geçerli.
          </p>
          <Link to="/login" className="font-medium hover:underline">
            Girişe dön
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-posta</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={forgot.isPending}>
            {forgot.isPending ? "Gönderiliyor..." : "Link gönder"}
          </Button>
          <p className="text-center text-sm">
            <Link to="/login" className="text-muted-foreground hover:text-foreground hover:underline">
              Girişe dön
            </Link>
          </p>
        </form>
      )}
    </AuthCard>
  );
}
